import React, { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { useMediaQuery } from "react-responsive"
import { useRecoilState } from "recoil"
import { ShowHeader } from "../../states/showHeader"
import { Box, Container, Grid, Typography } from "src/UILibrary"
import { Title } from "src/components/layout/Title"
import { ThumbItem } from "./components/ThumbItem"
import { SpaceItem } from "./components/SpaceItem"
import { MeetingItem } from "./components/MeetingItem"

import "src/styles/common.scss"

export const SpaceMeetingPage = () => {
  const { t } = useTranslation("translation", { keyPrefix: "space_meeting" })
  const isTablet = useMediaQuery({ query: "(min-width: 900px)" })
  const isMedium = useMediaQuery({ query: "(min-width: 690px)" })
  const [, setShowHeader] = useRecoilState(ShowHeader)

  useEffect(() => {
    setShowHeader(true)
  })

  return (
    <>
      <Title title={t("space_meeting_title")} sub_title="" />
      {isTablet ? (
        <Box
          mt={0}
          pt={0}
          pb={0}
          sx={{
            backgroundImage: `url(${process.env.REACT_APP_S3_URL}facility.jpg)`,
            backgroundPosition: "center",
          }}
        >
          <Grid container>
            <Grid item xs={6} md={4}>
              <Box color="info.contrastText" p={0}>
                <ThumbItem image="" color="white" opacity={0.7} />
              </Box>
            </Grid>
            <Grid item xs={6} md={4}>
              <Box color="info.contrastText" p={0}>
                <ThumbItem image="" color="white" opacity={0} />
              </Box>
            </Grid>
            <Grid item xs={6} md={4}>
              <Box color="info.contrastText" p={0}>
                <ThumbItem image="" color="white" opacity={0.7} />
              </Box>
            </Grid>
          </Grid>
        </Box>
      ) : (
        <Box
          mt={0}
          pt={0}
          pb={0}
          sx={{
            backgroundImage: `url(${process.env.REACT_APP_S3_URL}facility.jpg)`,
            backgroundPosition: "center",
          }}
        >
          <Box color="info.contrastText" p={0}>
            <ThumbItem image="" color="white" opacity={0} />
          </Box>
        </Box>
      )}

      <Container
        maxWidth="lg"
        sx={{ px: isTablet ? "80px!important" : "10px", py: isTablet ? "40px" : "20px", mb: "0px" }}
      >
        <Typography.Description
          className="weight500 notosans"
          color="textPrimary"
          fontSize={isTablet ? "18px" : "10px"}
          lineHeight={isTablet ? "25px" : "20px"}
        >
          {
            "イベントスペース、会議室の利用は事前にご相談ください。\nTEL：0766-30-3420\nmail：info@tasu-takaoka.com"
          }
        </Typography.Description>
        <MeetingItem
          image={`${process.env.REACT_APP_S3_URL}facility.jpg`}
          title="イベントスペース"
          description="最大50名収容可<br><br>貸出：スクリーン/プロジェクター/音響設備"
        />
        <SpaceItem
          image={`${process.env.REACT_APP_S3_URL}meeting_room_A.jpg`}
          title="会議室A"
          description="長机：4台<br>椅子：8席<br>貸出：43インチモニター/ホワイトボード"
        />
        <SpaceItem
          image={`${process.env.REACT_APP_S3_URL}meeting_room_B.jpg`}
          title="会議室B"
          description="長机：4台<br>椅子：8席<br>貸出：43インチモニター/ホワイトボード"
        />
        <SpaceItem
          image={`${process.env.REACT_APP_S3_URL}meeting_room_C.jpg`}
          title="会議室C"
          description="会議室C<br>長机：7台<br>椅子：13席<br>貸出：43インチモニター/ホワイトボード"
        />
        <MeetingItem
          image={`${process.env.REACT_APP_S3_URL}study_space_month.jpg`}
          title="スタディスペース"
          description="スタディスペースはどなたでも無料で勉強やリモートワークなどにご利用いただけます。"
        />
      </Container>
      <Container
        maxWidth="lg"
        sx={{
          px: isTablet ? "80px!important" : "10px",
          pt: "50px",
          pb: isMedium ? "230px !important" : "480px",
        }}
        className="main-body-with-footer"
      ></Container>
    </>
  )
}
